import React, { useEffect, useState } from 'react';
import Input from 'antd/lib/input';
import Modal from 'antd/lib/modal';
import Table from 'antd/lib/table';
import Checkbox from 'antd/lib/checkbox';
import Button from 'antd/lib/button';


import { formatStatusValue } from '../../../../../../utils/formatting';

// ICONS
import searchIconLight from '../../../../../../icons/search.svg';
import searchIconDark from '../../../../../../icons/search-dark.svg';

import editIcon from '../../../../../MonitoringPage/components/MonitoringDetails/components/assets/edit.svg';

import './AdditionalPointsModal.less';

const { Search } = Input;

export const AdditionalPointsModal = (props) => {
  const { defaultDataPoints, additionalDataPoints, currentAdditionalDataPoints, saveChanges, onCancel, theme } = props;
  const [filteredDataPoints, setFilteredDataPoints] = useState([]);
  const [selectedDataPointTags, setSelectedDataPointTags] = useState([]);
  const [searchValue, setSearchValue] = useState('');
  const themedSearchIcon = theme === 'dark' ? searchIconDark : searchIconLight;

  useEffect(() => {
    if (currentAdditionalDataPoints.length > 0) {
      const currentDataPointTags = [];
      currentAdditionalDataPoints.forEach((dataPoint) => currentDataPointTags.push(dataPoint.tag));
      setSelectedDataPointTags(currentDataPointTags);
    }

    if (searchValue) {
      const tempRegisterList = additionalDataPoints.filter((item) =>
        item.display_name.replace(/\s/g, '').toLowerCase().includes(searchValue.replace(/\s/g, '').toLowerCase()),
      );
      setFilteredDataPoints(tempRegisterList);
    } else {
      setFilteredDataPoints(
        additionalDataPoints.map(o => ({
          ...o,
          status: formatStatusValue(o.status),
        }))
      );
    }
  }, [searchValue]);

  const handleCheckboxChange = (tag) => {
    const updatedDataPoints = selectedDataPointTags.includes(tag)
      ? selectedDataPointTags.filter((item) => item !== tag)
      : [...selectedDataPointTags, tag];

    setSelectedDataPointTags(updatedDataPoints);
  };

  const selectAllPoints = () => {
    const allTags = filteredDataPoints.map((p) => p.tag);
    setSelectedDataPointTags(allTags);
  };
  const clearAllPoints = () => {
    // const allTags = filteredDataPoints.map((p) => p.tag);
    setSelectedDataPointTags([]);
  };

  const updateDataPoints = () => {
    // Create a list of default data point tags and combine it with the selected additional tags
    const defaultDataPointTags = [];
    defaultDataPoints.forEach((dataPoint) => defaultDataPointTags.push(dataPoint.tag));
    const completeDataPointTags = defaultDataPointTags.concat(selectedDataPointTags);
    saveChanges(completeDataPointTags);
  };

  const defaultDataPointsColumns = [
    {
      title: 'ALERT POINTS',
      dataIndex: 'display_name',
    },
    // {
    //   title: 'DATA TAG',
    //   dataIndex: 'tag',
    // },
  ];

  const additionalDataPointsColumns = [
    {
      title: 'COMPARE ADDITIONAL POINTS',
      dataIndex: ['display_name', 'tag'],
      render: (displayName, dataPoint) => {
        const checked = selectedDataPointTags.includes(dataPoint.tag);
        return (
          <label htmlFor={dataPoint.tag} key={dataPoint.tag}>
            <div className="alerts-details-datapoints-modal-checkbox-column">
              <Checkbox id={dataPoint.tag} checked={checked} onChange={() => handleCheckboxChange(dataPoint.tag)} />
              <span>{dataPoint.display_name}</span>
            </div>
          </label>
        );
      },
    },
    // {
    //   title: 'DATA TAG',
    //   dataIndex: 'tag',
    // },
    {
      title: 'LATEST READING',
      dataIndex: 'status',
      className: 'desktop',
    },
  ];

  return (
    <Modal
      className={`alerts-details-datapoints-modal alerts-details-datapoints-modal-${theme}`}
      open
      closable
      keyboard
      maskClosable
      centered
      title={`Compare Additional Points (${selectedDataPointTags.length})`}
      okText="Compare"
      cancelButtonProps={{ className: 'alerts-details-datapoints-modal-button-cancel' }}
      okButtonProps={{ className: 'alerts-details-datapoints-modal-button-compare' }}
      onCancel={onCancel}
      onOk={updateDataPoints}
    >
      <Table
        className="alerts-details-datapoints-modal-table alerts-details-datapoints-modal-table-default"
        columns={defaultDataPointsColumns}
        dataSource={defaultDataPoints}
        pagination={false}
      />
      <div className="alerts-details-datapoints-modal-search">
        <Search
          id="search"
          placeholder="Search for additional points"
          onChange={(e) => {
            e.persist();
            setSearchValue(e.target.value);
          }}
          onSearch={(e) => {
            e.persist();
            setSearchValue(e.target.value);
          }}
          prefix={<img src={themedSearchIcon} alt="search icon" />}
        />
      </div>
      <div className="monitoring-details-card__button-wrapper select-buttons">
        <Button
          block
          size="medium"
          className="monitoring-details-card__button"
          style={{ width: 'min-content' }}
          onClick={() => selectAllPoints()}
        >
          <div className="monitoring-details-card__buton-text">
            <img className="edit-img" src={editIcon} alt="edit-icon" />
            Select all points
          </div>
        </Button>
        <Button
          block
          size="medium"
          className="monitoring-details-card__button"
          style={{ width: 'min-content' }}
          onClick={() => clearAllPoints()}
        >
          <div className="monitoring-details-card__buton-text">
            <img className="edit-img" src={editIcon} alt="edit-icon" />
            Clear all points
          </div>
        </Button>

      </div>
      <Table
        className="alerts-details-datapoints-modal-table alerts-details-datapoints-modal-table-additional"
        columns={additionalDataPointsColumns}
        dataSource={filteredDataPoints}
        pagination={false}
      />
    </Modal>
  );
};
